function u(n, r) {
  return r.reduce(function(e, t) {
    return e[t] = n, e;
  }, {});
}
export {
  u as default
};
